import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { MotivoPerdaVendaConcorrenteFormComponent } from './motivo-perda-venda-concorrente-form.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        MotivoPerdaVendaConcorrenteFormComponent
    ],
    exports: [
        MotivoPerdaVendaConcorrenteFormComponent
    ]
})
export class MotivoPerdaVendaConcorrenteFormModule { }
